function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPaymentLogoVisa = function SvgIconPaymentLogoVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 448 256"
    },
    viewBox: "0 0 448 256"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M231.1 105.5c-.2 17.3 15.4 27 27.2 32.7 12.1 5.9 16.2 9.7 16.1 15-.1 8.1-9.6 11.6-18.6 11.8-15.6.3-24.7-4.2-31.9-7.6l-5.6 26.4c7.2 3.3 20.7 6.2 34.5 6.4 32.7 0 54-16.1 54.1-41.1.1-31.7-43.9-33.5-43.5-47.6.1-4.3 4.2-8.9 13.2-10.1 4.5-.6 16.7-1.1 30.6 5.3l5.4-25.5c-7.5-2.8-17.1-5.3-29.1-5.3-30.6-.1-52.2 16.2-52.4 39.6M365.2 68c-6 0-11 3.5-13.3 8.8l-46.7 111.3h32.6l6.5-17.9h39.9l3.7 17.9h28.8L391.7 68h-26.5zm4.5 32.5 9.4 45.1h-25.8l16.4-45.1zM191.6 68l-25.7 120.1H197L222.6 68h-31zm-46 0-32.4 81.8-13.1-69.5C98.6 72.5 92.6 68 85.8 68H32.9l-.7 3.5c10.9 2.3 23.1 6.1 30.6 10.2 4.5 2.5 5.9 4.6 7.4 10.6L95 188.2h32.9L178.2 68h-32.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1334cb",
      enableBackground: "new"
    }
  }));
};
export default SvgIconPaymentLogoVisa;